<template>
	<div class="hello animate__animated animate__fadeIn">
		<div class="hello_box">
			<Head :hasEnter="false" :hasProject="false"></Head>
			<!-- 项目统计 -->
			<div class="left_top">
				<div class="top_title">设备统计</div>
				<div class="top_access">
					<div class="access_item monitor_box">
						<div class="item_bg">
							<div class="item_access monitor"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">视频监控</div>
							<div class="txt_one">{{ eqptData.monitor.online }}/{{ eqptData.monitor.total }}</div>
						</div>
					</div>
					<div class="access_item led_box">
						<div class="item_bg">
							<div class="item_access led"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">LED控制主板</div>
							<div class="txt_one">{{ eqptData.led.online }}/{{ eqptData.led.total }}</div>
						</div>
					</div>
					<div class="access_item tower_box">
						<div class="item_bg">
							<div class="item_access tower"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">塔机黑匣子</div>
							<div class="txt_one">{{ eqptData.crane.online }}/{{ eqptData.crane.total }}</div>
						</div>
					</div>
					<div class="access_item elevator_box">
						<div class="item_bg">
							<div class="item_access elevator"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">施工升降机</div>
							<div class="txt_one">{{ eqptData.elevator.online }}/{{ eqptData.elevator.total }}</div>
						</div>
					</div>
					<div class="access_item face_box">
						<div class="item_bg">
							<div class="item_access face"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">人脸设备</div>
							<div class="txt_one">{{ eqptData.face.online }}/{{ eqptData.face.total }}</div>
						</div>
					</div>
					<div class="access_item environment_box">
						<div class="item_bg">
							<div class="item_access environment"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">环境监测</div>
							<div class="txt_one">{{ eqptData.env.online }}/{{ eqptData.env.total }}</div>
						</div>
					</div>
					<div class="access_item key_box">
						<div class="item_bg">
							<div class="item_access key"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">门禁设备</div>
							<div class="txt_one">{{ eqptData.access.online }}/{{ eqptData.access.total }}</div>
						</div>
					</div>
					<div class="access_item helmet_box">
						<div class="item_bg">
							<div class="item_access helmet"></div>
						</div>
						<div class="item_txt">
							<div class="txt_one">AI监测</div>
							<div class="txt_one">{{ eqptData.helmet.online }}/{{ eqptData.helmet.total }}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 项目列表 -->
			<div class="left_center">
				<div class="project_total">项目总数量: <span>{{ projectCount }}</span> 个</div>
				<div class="center_title">项目列表</div>
				<div class="center_search">
					<div class="search_title">项目名称</div>
					<input type="text" class="search_input" placeholder="请输入项目名称" v-model="searchName" @input="fnSearchSame"/>
					<div class="search_btn"></div>
				</div>
				<div class="center_list">
					<div class="list_title">
						<div class="title_line">
							<div class="title_item">项目编号</div>
							<div class="title_item">项目名称</div>
							<div class="title_item">创建时间</div>
							<div class="title_item">状态</div>
							<div class="title_item">操作</div>
						</div>
					</div>
					<div class="list_boxes">
						<div class="list_box">
							<div v-if="projectData">
								<div class="list_item" v-for="(item,index) in projectData" :key="index">
									<div class="item_txt" @click="goProject(item)">{{ item.id }}</div>
									<div class="item_txt" :title="item.name" @click="goProject(item)">{{ item.name }}</div>
									<div class="item_txt" :title="item.create_at" @click="goProject(item)">{{ item.create_at }}</div>
									<div class="item_txt" @click="goProject(item)">{{ item.status==0?'禁用':'启用' }}</div>
									<div class="item_txt">
										<button class="item_btn blue" @click="openProjectEdit(item)">编辑</button>
										<button class="item_btn red" @click="goProject(item)">项目端</button>
										<button class="item_btn blue" @click="getCenter(item)">定位</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 项目考勤统计 -->
			<div class="left_bottom">
				<div class="bottom_title">项目考勤统计</div>
				<div class="bottom_box">
					<div class="box_attendance">
						<div class="img_count">{{ attendance.attTotal }}</div>
						<!-- <div class="project-rate" id="personAttendance" ref="personAttendance"></div> -->
					</div>
					<div class="box_total">
						<div class="project-rate" id="personTotal" ref="personTotal"></div>
					</div>
					<div class="box_count">
						<div class="img_count">{{ attendance.inTotal }}</div>
						<!-- <div class="project-rate" id="personCount" ref="personCount"></div> -->
					</div>
				</div>
				<div class="bottom_txt">
					<div class="txt">总考勤记录条数</div>
					<div class="txt">项目总人数</div>
					<div class="txt">场内人数</div>
				</div>
				<div class="bottom_list">
					<div class="list_line">
						<div class="item">
							<div class="color pink"></div>
							<div class="txt">小于22岁</div>
						</div>
						<div class="item">
							<div class="color orange"></div>
							<div class="txt">大于65岁</div>
						</div>
						<div class="item">
							<div class="color gray"></div>
							<div class="txt">未知</div>
						</div>
					</div>
					<div class="list_line">
						<div class="item">
							<div class="color green"></div>
							<div class="txt">22-25岁</div>
						</div>
						<div class="item">
							<div class="color blue"></div>
							<div class="txt">26-35岁</div>
						</div>
						<div class="item">
							<div class="color yellow"></div>
							<div class="txt">36-45岁</div>
						</div>
						<div class="item">
							<div class="color lightblue"></div>
							<div class="txt">46-55岁</div>
						</div>
						<div class="item">
							<div class="color red"></div>
							<div class="txt">56-65岁</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 地图 -->
			<div class="center_center">
				<GDMaps :MapData="MapData"></GDMaps>
			</div>
			<!-- 实时考勤统计 -->
			<div class="center_bottom">
				<div class="bottom_title"><span>实时考勤统计</span></div>
				<div class="bottom_chart" ref="attendanceChartAll"></div>
				<button class="bottom_btn" @click="fnUpdataAttChart"></button>
			</div>
			<!-- 考勤按月统计 -->
			<div class="right_top">
				<div class="top_title">考勤按月统计表</div>
				<div class="top_search">
					<el-select size="small" v-model="searchProName" :popper-append-to-body="false" filterable placeholder="请选择项目名" class="search_select">
						<el-option label="请选择项目名称" value=""></el-option>
						<el-option v-for="item in projectName" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<div class="search_date">
						<el-date-picker
							style="width: 100px;"
							size="small"
							v-model="searchMonth"
							type="month"
							value-format="yyyy-MM">
						</el-date-picker>
					</div>
					<button class="search_btn" @click="fnSearchAttendance"></button>
				</div>
				<div class="top_list">
					<div class="list_title">
						<div class="title_line">
							<div class="title_item"><span>项目名称</span></div>
							<div class="title_item">
								<span>总人数</span>
								<div class="sort">
									<img v-if="sortTotal" src="../../../assets/img/enter_list_totop_o.png" @click="fnSortTotal"/>
									<img v-else src="../../../assets/img/enter_list_totop_w.png" @click="fnSortTotal"/>
									<img v-if="sortTotal" src="../../../assets/img/enter_list_tobottom_w.png" @click="fnSortTotal"/>
									<img v-else src="../../../assets/img/enter_list_tobottom_o.png" @click="fnSortTotal"/>
								</div>
							</div>
							<div class="title_item">
								<span>出勤人数</span>
								<div class="sort">
									<img v-if="sortAttr" src="../../../assets/img/enter_list_totop_o.png" @click="fnSortAtt"/>
									<img v-else src="../../../assets/img/enter_list_totop_w.png" @click="fnSortAtt"/>
									<img v-if="sortAttr" src="../../../assets/img/enter_list_tobottom_w.png" @click="fnSortAtt"/>
									<img v-else src="../../../assets/img/enter_list_tobottom_o.png" @click="fnSortAtt"/>
								</div>
							</div>
							<div class="title_item">
								<span>出勤率</span>
								<div class="sort">
									<img v-if="sortAttrRate" src="../../../assets/img/enter_list_totop_o.png" @click="fnSortAttRate"/>
									<img v-else src="../../../assets/img/enter_list_totop_w.png" @click="fnSortAttRate"/>
									<img v-if="sortAttrRate" src="../../../assets/img/enter_list_tobottom_w.png" @click="fnSortAttRate"/>
									<img v-else src="../../../assets/img/enter_list_tobottom_o.png" @click="fnSortAttRate"/>
								</div>
							</div>
							<div class="title_item">
								<span>考勤总条数</span>
								<div class="sort">
									<img v-if="sortAttrAll" src="../../../assets/img/enter_list_totop_o.png" @click="fnSortAttAll"/>
									<img v-else src="../../../assets/img/enter_list_totop_w.png" @click="fnSortAttAll"/>
									<img v-if="sortAttrAll" src="../../../assets/img/enter_list_tobottom_w.png" @click="fnSortAttAll"/>
									<img v-else src="../../../assets/img/enter_list_tobottom_o.png" @click="fnSortAttAll"/>
								</div>
							</div>
						</div>
					</div>
					<div class="list_boxes">
						<div class="list_box">
							<div v-if="attendanceData">
								<div class="list_item" v-for="(item,index) in attendanceData" :key="index">
									<div class="item_one" :title="item.project_name">{{ item.project_name }}</div>
									<div class="item_one">{{ item.count_person }}</div>
									<div class="item_one">{{ item.attendance_person }}</div>
									<div class="item_one">{{ item.att_rate }}</div>
									<div class="item_one">{{ item.att_count }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 安全统计 -->
			<div class="right_center">
				<div class="center_title">安全统计</div>
				<div class="center_list">
					<div class="list_title">
						<div class="title_line">
							<div class="title_item">排名</div>
							<div class="title_item">项目名称</div>
							<div class="title_item">准时整改</div>
							<div class="title_item">超时整改</div>
							<div class="title_item">整改中</div>
							<div class="title_item">未整改</div>
							<div class="title_item">整改率</div>
						</div>
					</div>
					<div class="list_boxes">
						<div class="list_box">
							<div v-if="safetyData">
								<div class="list_item" v-for="(item,index) in safetyData" :key="index">
									<div class="item_one">{{ index + 1 }}</div>
									<div class="item_one" :title="item._name">{{ item._name }}</div>
									<div class="item_one">{{ item._timeNum }}</div>
									<div class="item_one">{{ item._timeoutNum }}</div>
									<div class="item_one">{{ item._ingNum }}</div>
									<div class="item_one">{{ item._notNum }}</div>
									<div class="item_one">{{ item._rate }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 质量统计 -->
			<div class="right_bottom">
				<div class="bottom_title">质量统计</div>
				<div class="bottom_list">
					<div class="list_title">
						<div class="title_line">
							<div class="title_item">排名</div>
							<div class="title_item">项目名称</div>
							<div class="title_item">准时整改</div>
							<div class="title_item">超时整改</div>
							<div class="title_item">整改中</div>
							<div class="title_item">未整改</div>
							<div class="title_item">整改率</div>
						</div>
					</div>
					<div class="list_boxes">
						<div class="list_box">
							<div v-if="qualityData">
								<div class="list_item" v-for="(item,index) in qualityData" :key="index">
									<div class="item_one">{{ index + 1 }}</div>
									<div class="item_one" :title="item._name">{{ item._name }}</div>
									<div class="item_one">{{ item._timeNum }}</div>
									<div class="item_one">{{ item._timeoutNum }}</div>
									<div class="item_one">{{ item._ingNum }}</div>
									<div class="item_one">{{ item._notNum }}</div>
									<div class="item_one">{{ item._rate }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 项目编辑 -->
			<div class="dialog" v-if="showProjectEdit">
				<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="编辑项目" center :visible.sync="showProjectEdit" width="600px">
					<el-form ref="form" label-width="100px" size="small">
						<el-form-item label="项目名称"><el-input v-model="form.name" style="width: 405px;display: inline-block;" placeholder="项目名称"></el-input></el-form-item>
						<el-form-item label="项目操作端">
							<el-input v-model="form.edit" style="width: 200px;display: inline-block;" disabled placeholder="请输入操作端账号"></el-input>
							<el-input v-model="form.editPwd" style="width: 200px;display: inline-block;" placeholder="请输入操作端密码"></el-input>
						</el-form-item>
						<el-form-item label="项目查看端">
							<el-input v-model="form.see" style="width: 200px;display: inline-block;" disabled placeholder="请输入查看端账号"></el-input>
							<el-input v-model="form.seePwd" style="width: 200px;display: inline-block;" placeholder="请输入查看端密码"></el-input>
						</el-form-item>
						<el-form-item label="项目地址"><el-input v-model="form.address" style="width: 405px;display: inline-block;" placeholder="请输入项目地址"></el-input></el-form-item>
						<el-form-item label="项目经度"><el-input v-model="form.lat" style="width: 405px;display: inline-block;" placeholder="请输入项目经度"></el-input></el-form-item>
						<el-form-item label="项目纬度"><el-input v-model="form.lng" style="width: 405px;display: inline-block;" placeholder="请输入项目纬度"></el-input></el-form-item>
						<el-form-item label="">
							<!-- <div @click="fnGetLng()" style="color: #007AFF;cursor: pointer;">点击此处查询经纬度信息,示例：经度:29.40183,纬度:106.544707</div> -->
							<div @click="showMap=true" style="color: #007AFF;cursor: pointer;">点击此处查询经纬度信息,示例：经度:29.40183,纬度:106.544707</div>
						</el-form-item>
						<el-form-item label="启用状态">
							<el-radio-group v-model="form.status">
								<el-radio label="0">禁用</el-radio>
								<el-radio label="1">启用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search-btn red" @click="showProjectEdit = false"><span>取消</span></div>
							<div class="search-btn" @click="fnSaveProject"><span>保存</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
            <div class="dialog_setMap" v-if="showMap">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :close-on-click-modal="false" :modal="false" title="获取经纬度" :visible.sync="showMap" center>
                    <div class="show_map">
                        <GDMapsLocation @fnGetLocation="fnGetLocation"></GDMapsLocation>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showMap=false"><span>关 闭</span></div>
                            <div class="search-btn" @click="fnGetLocationYes"><span>确 定</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
		</div>
	</div>
</template>

<script>
import request from '@/utils/enter';//企业端请求
import Head from '@/views/Header/HeaderDefault/headerEnterprise';
import axios from 'axios';
import {getEnterInfo,setToken,setUserInfo,setEnterStatus} from '@/utils/auth'
import echarts from 'echarts';
import GDMaps from '@/components/Map/map.vue'
import GDMapsLocation from '@/components/Map/location.vue'
export default {
	name: 'index',
	data() {
		return {
			projectRateChart: null,// 项目数量统计
			projectCount: 0,// 项目总数
			searchName: '',// 搜索项目名称
			projectData: [],// 项目列表
			projectDataAll: [],// 项目列表备份
			showProjectEdit: false,// 编辑项目弹窗
			MapData:{
				projectData:[],
				center: [106.54451,29.402152],// 设置地图中心点位置
			},
			form: { // 项目编辑
				id: '',
				name: '',
				see: '',
				seePwd: '',
				edit: '',
				editPwd: '',
				address: '',
				lat: '',// 经度
				lng: '',// 纬度
				status: '',// 状态
			},
			attendance:{// 考勤统计
				perTotal: 0,
				attTotal: 0,
				inTotal: 0,
			},
			personTotal:{},// 项目总人数年龄统计
			perTotalRateChart: null,
			personAttendance:{},// 总考勤条数年龄统计
			perAttendanceRateChart: null,
			personCount:{},// 场内人数年龄统计
			perCountRateChart: null,
			eqptData:{// 设备统计数据
				face:{ online:0, total:0 },// 人脸
				access:{ online:0, total:0 },// 门禁
				led:{ online:0, total:0 },// led控制主板
				monitor:{ online:0, total:0 },// 监控
				crane:{ online:0, total:0 },// 塔机
				env:{ online:0, total:0 },// 环境监测
				elevator:{ online:0, total:0 },// 升降机
				helmet:{ online:0, total:0 }// AI监测
			},
			monitorToken:'',// 获取视频监控token
			attendanceChartAll: null,// 实时考勤统计折线图
			projectDatas: [],// 项目-> 实时考勤统计
			projectDataLine: [],// 项目半透明柱状图总人数 -> 实时考勤统计
			projectDataBar: [],// 项目实心柱状图考勤人数 -> 实时考勤统计
			projectDataInBar: [],// 项目实心柱状图场内人数 -> 实时考勤统计
			projectDataRate: [],// 项目折线图出勤率 -> 实时考勤统计
			isLock: false,// 实时刷新
			projectName:[],// 搜索框项目名
			attendanceData: [],// 考勤按月统计
			searchProName: '',// 搜索项目名称
			searchMonth: '',// 搜索月份
			sortTotal: true,// 总人数排序
			sortAttr: true,// 出勤人数排序
			sortAttrRate: true,// 出勤率排序
			sortAttrAll: true,// 总考勤条数排序
			safetyData:[],// 安全统计
			qualityData:[],// 质量统计
            showMap: false,// 地图坐标拾取
            mapInfo:{
                lng: '',
                lat: '',
            },
		}
	},
	components: {
		Head,
		GDMaps,
        GDMapsLocation
	},
	mounted() {
		this.fnInit()
	},
	methods: {
		fnInit(){
			// 获取项目统计数量
			this.fnGetProjectNum()
			// 获取项目列表
			this.fnGetProjectList()
			// 获取项目考勤统计
			this.fnGetAttendanceNum()
			// 获取视频监控设备token地址
			this.fnGetMonitorTokenAll()
			// 获取设备统计数据
			this.fnGetEquipmentDataAll()
			// 获取实时考勤统计图数据
			this.fnGetAttendanceData()
			// 获取考勤按月统计数据
			this.fnGetAttrMonthData({type: 1})
			// 获取搜索框项目名
			this.fnGetProjectName()
			// 获取安全统计数据
			// this.fnGetSafetyData()
			// 获取质量统计数据
			// this.fnGetQualityData()
		},
		// 获取项目经纬度 跳转高德地图
		// fnGetLng(){
		// 	window.open("https://lbs.amap.com/console/show/picker")
		// },
		// 项目定位
		getCenter(_item){
			let _lng = _item.lng
			let _lat = _item.lat
			if(_lng&&_lat){
				let _arr = []
				_arr.push(_lng)
				_arr.push(_lat)
				this.MapData.center = _arr
			}else{
				this.$message.warning("请填写该项目的经纬度信息！")
			}
		},
		// 获取项目统计数量
		fnGetProjectNum(){
			request({
			  url: 'enterprice/getProjectCount',
			  method: 'GET',
			}).then(res => {
				this.projectCount = res.data.count
			}).catch(err => {
			  this.$message.error(err.data)
			})
		},
		// 获取项目列表
		fnGetProjectList(){
			request({
			  url: 'enterprice/getProjectList',
			  method: 'GET',
			}).then(res => {
				this.projectData = res.data
				this.projectDataAll = res.data
				this.fnGetMapData(res.data)
			}).catch(err => {
			  this.$message.error(err.data)
			})
		},
		fnGetMapData(_data){
			if(_data.length > 0){
				let _arr = []
				for(var i in _data){
					let _reference = []
					let _lng = _data[i].lng?_data[i].lng:''
					let _lat = _data[i].lat?_data[i].lat:''
					if(_lng&&_lat){
						_reference.push(_lng)
						_reference.push(_lat)
					}
					let _referenceStr =  _reference ? _reference.join(',') : ''
					let _address = _data[i].address ? _data[i].address : ''
					let _name = _data[i].name ? _data[i].name : ''
					if(_referenceStr){
						let _obj = {
							position: _referenceStr,
							address: _address,
							name: _name
						}
						_arr.push(_obj)
					}
				}
				this.MapData.projectData = _arr
				this.MapData.center = _arr[0].position.split(',')
			}
		},
		// 搜索可匹配项目
		fnSearchSame(){
			this.projectData = this.projectDataAll.filter(data => !this.searchName || data.name.toLowerCase().includes(this.searchName.toLowerCase()))
		},
		// 跳转查看项目端
		goProject(_data){
			let _id = _data.id
			let _pwd = ''
			for(let i in _data.account){
				if(_data.account[i].auth == 'edit'){
					_pwd = _data.account[i].password
				}
			}
			if(!_pwd){
				this.$message.warning('请编辑设置项目端账号！')
				return
			}
			let _obj = {
				username: _id,
				password: _pwd,
				type: 2
			}
			request({
			  url: "/login",
			  method: "POST",
			  notLoading: true,
			  data: _obj
			})
			.then(res => {
				setToken(res.data.token);
				setUserInfo(res.data);
				setEnterStatus(true)
				this.$router.push({path: '/index'});
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 打开编辑项目弹窗
		openProjectEdit(_data){
			let _seepwd = ''
			let _editpwd = ''
			if(_data.account.length > 0){
				for(let i in _data.account){
					if(_data.account[i].auth == 'see'){
						_seepwd = _data.account[i].password
					}
					if(_data.account[i].auth == 'edit'){
						_editpwd = _data.account[i].password
					}
				}
			}
			this.form.id = _data.id ? _data.id : ''
			this.form.name = _data.name ? _data.name : ''
			this.form.address = _data.address ? _data.address : ''
			this.form.lat = _data.lat ? _data.lat : ''
			this.form.lng = _data.lng ? _data.lng : ''
			this.form.status = _data.status ? ''+_data.status : ''
			this.form.see = _data.id ? _data.id : ''
			this.form.seePwd = _seepwd
			this.form.edit = _data.id ? _data.id : ''
			this.form.editPwd = _editpwd
			this.showProjectEdit = !this.showProjectEdit
		},
		// 保存编辑项目
		fnSaveProject(){
			if(this.form.editPwd === this.form.seePwd){
				this.$message.warning("查看端与操作端密码不能一致！")
				return
			}
			// 校验经度
			if(this.form.lng!=''){
				let longrg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
				if(!longrg.test(this.form.lng)){
					return this.$message.warning("经度整数部分为0-180,小数部分为0到6位!");

				}
			}
			// 校验纬度
			if(this.form.lat!=''){
				let latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
				if(!latreg.test(this.form.lat)){
						return this.$message.warning("纬度整数部分为0-90,小数部分为0到6位!");
				}
			}
			if((this.form.lng==''&&this.form.lat!='')||(this.form.lat==''&&this.form.lng)){
				return this.$message.warning("如果填写经纬度，经、纬度两项都需填写！");
			}
			let _obj = {
				name: this.form.name,
				project_id: this.form.id,
				seepwd: this.form.seePwd,
				editpwd: this.form.editPwd,
				address: this.form.address,
				lat: this.form.lat,
				lng: this.form.lng,
				status: this.form.status
			}
			request({
			  url: "enterprice/editProject",
			  method: "POST",
			  data: _obj
			})
			.then(res => {
				this.$message.success(res.data);
				this.fnInit()
				this.showProjectEdit = !this.showProjectEdit
			})
			.catch(err => {
				this.$message.error(err.data);
				this.showProjectEdit = !this.showProjectEdit
			});
		},
		// 获取项目考勤统计
		fnGetAttendanceNum(){
			request({
			  url: "enterprice/getAttTotal",
			  method: "GET",
			})
			.then(res => {
				this.attendance.attTotal = res.data.att // 总考勤人数
				this.attendance.inTotal = res.data.inout // 场内总人数
				this.personTotal = res.data.person
				this.$nextTick(()=>{
					this.fnperTotalRateChart()
				})
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 初始化项目总人数
		fnperTotalRateChart() {
			this.perTotalRateChart = echarts.init(this.$refs.personTotal);
			this.perTotalRateChart.setOption({
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				legend: {
					orient: 'vertical',
					x: 'right',
					show: false,
					data: ['小于22岁', '大于65岁', '未知','22-25岁','26-35岁','36-45岁','46-55岁','56-65岁']
				},
				color: ['#F368E0','#E67E23','#8A8F97','#6CEEAF','#4D81F7','#FFCC3F','#9BF9FC','#FF6A72'],
				series: [
					{
						name: '项目总人数',
						type: 'pie',
						radius: ['60%', '90%'],
						avoidLabelOverlap: false,
						label: {
							show:false,
							position: 'center'
						},
						emphasis: {
							label:{
								show: true,
								fontSize: '12',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: [
							{ value: this.personTotal.less_22, name: '小于22岁'},
							{ value: this.personTotal.more_65, name: '大于65岁'},
							{ value: this.personTotal.other, name: '未知'},
							{ value: this.personTotal['22To25'], name: '22-25岁'},
							{ value: this.personTotal['26To35'], name: '26-35岁'},
							{ value: this.personTotal['36To45'], name: '36-45岁'},
							{ value: this.personTotal['46To55'], name: '46-55岁'},
							{ value: this.personTotal['56To65'], name: '56-65岁'},
						]
					}
				]
			});
		},
		// 获取监控地址token
		fnGetMonitorTokenAll() {
			request({
				url: 'zgj-monitor/get_token',
				method: 'GET'
			})
			.then(res => {
				this.monitorToken = res.data;
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 获取设备统计数据
		fnGetEquipmentDataAll(){
			request({
			  url: 'eqptStat/count',
			  method: 'GET'
			}).then(res => {
				if(res.data){
					// 设备统计数据
					this.eqptData.face = res.data.face
					this.eqptData.access = res.data.access
					this.eqptData.crane = res.data.crane
					this.eqptData.env = res.data.env
					this.eqptData.elevator = res.data.elevator
					this.eqptData.led = res.data.led
					this.eqptData.helmet = res.data.helmet
					// 监控设备数据初始化
					this.eqptData.monitor.online = 0
					this.eqptData.monitor.total = 0
					// 循环判断监控设备是否在线
					let _data = res.data.monitor
					for(var i in _data){
						this.eqptData.monitor.total++
						this.fnGetDeviceInfo(_data[i])
					}
				}
			}).catch(err => {
			  this.$message.error(err.data)
			})
		},
		// 从萤石云获取设备信息
		fnGetDeviceInfo(_deviceSerial) {
			let param = new URLSearchParams();
			param.append('accessToken', this.monitorToken);
			param.append('deviceSerial', _deviceSerial);
			axios({
				method: 'post',
				url: 'https://open.ys7.com/api/lapp/device/info',
				data: param
			})
			.then(res => {
				if (res.data.code == 200) {
					if(res.data.data.status == 1){
						this.eqptData.monitor.online+=1
					}
				} else {
					this.$message.warning(err.msg);
				}
			})
			.catch(err => {
				this.$message.warning(err.msg);
			});
		},
		// 获取实时考勤统计图数据
		fnGetAttendanceData(){
			request({
			  url: "enterprice/getRealTimeAtt",
			  method: "GET",
				params:{
					type: 1,
				}
			})
			.then(res => {
				if(res.data){
					let _projectData = res.data;
					this.projectDatas = []; // 项目
					this.projectDataLine = []; // 总人数
					this.projectDataBar = [];// 考勤人数
					this.projectDataInBar = [];// 场内人数
					this.projectDataRate = [];// 出勤率
					for (let _key in _projectData) {
						this.projectDatas.push(_projectData[_key]["project_name"]);
						this.projectDataLine.push(_projectData[_key]["count_person"]);
						this.projectDataBar.push(_projectData[_key]["attendance_person"]);
						this.projectDataInBar.push(_projectData[_key]['in_place_count']);
						let _rate = _projectData[_key]["count_person"] / _projectData[_key]["attendance_person"];
						_rate = _rate ? parseInt(_rate * 100) : 0;
						this.projectDataRate.push(_rate == _rate ? _rate : 0);
					}
				this.fnAttendanceChartAll();
				}
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 初始化实时考勤统计图
		fnAttendanceChartAll() {
		  let _option = {
		    tooltip: {
		      trigger: "axis",
		      backgroundColor: "rgba(255,255,255,0.1)",
		      axisPointer: {
		        type: "shadow",
		        label: {
		          show: true,
		          backgroundColor: "#7B7DDC"
		        }
		      }
		    },
		    legend: {
		      data: [ "总人数", '考勤人数', '场内人数', "出勤率"],
		      textStyle: {
		        color: "rgba(255,255,255,0.7)",
		      },
		      top: "4%"
		    },
		    grid: {
		      x: "1%",
		      width: "88%",
		      left: "6%",
		      y: "20%"
		    },
		    xAxis: {
		      data: this.projectDatas,
		      axisLine: {
		        lineStyle: {
		          color: "#00CAFC"
		        }
		      },
		      axisTick: {
		        show: false
		      }
		    },
		    yAxis: [{
					splitLine: {
						show: true,
						lineStyle:{
							color: "rgba(66,132,247,0.1)"
						}
					},
					axisLine: {
						lineStyle: {
							color: "#00CAFC"
						}
					},
					axisLabel: {
						formatter: "{value}"
					}
				},
				{
					name: "出勤率(%)",
					splitLine: { show: false },
					axisLine: {
						lineStyle: {
							color: "#00CAFC"
						}
					},
					axisLabel: {
						formatter: "{value}"
					}
				}
			],
			series: [
				{
					name: "出勤率",
					type: "line",
					smooth: true,
					showAllSymbol: true,
					symbol: "emptyCircle",
					symbolSize: 8,
					yAxisIndex: 1,
					itemStyle: {
						normal: {
							color: "#FFD060"
						}
					},
					data: this.projectDataRate
				},
				{
					name: "场内人数",
					type: "bar",
					barGap: "-100%",
					barWidth: 30,
					itemStyle: {
						normal: {
							barBorderRadius: 5,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: "rgba(215,81,88,0.7)" },
								{ offset: 0.3, color: "rgba(215,81,88,0.5)" },
								{ offset: 1, color: "rgba(215,81,88,0.3)" }
							])
						}
					},
					data: this.projectDataInBar
				},
				{
					name: "考勤人数",
					type: "bar",
					barWidth: 25,
					barGap: "-100%",
					itemStyle: {
						normal: {
							barBorderRadius: 5,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: "rgba(136,90,252,0.9)" },
								{ offset: 0, color: "rgba(136,90,252,0.7)" },
								{ offset: 1, color: "rgba(136,90,252,0.5)" }
							])
						}
					},
					data: this.projectDataBar
				},
				{
					name: "总人数",
					type: "bar",
					barGap: "-100%",
					barWidth: 20,
					itemStyle: {
						normal: {
							barBorderRadius: 5,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: "rgba(52,121,255,0.7)" },
								{ offset: 0.2, color: "rgba(52,121,255,0.5)" },
								{ offset: 1, color: "rgba(52,121,255,0.3)" }
							])
						}
					},
					z: -12,
					data: this.projectDataLine
				}]
		  };
		  this.attendanceChartAll = echarts.init(this.$refs.attendanceChartAll);
		  this.attendanceChartAll.setOption(_option);
		},
		// 主动触发更新实时考勤统计图
		fnUpdataAttChart(){
			if(this.isLock){
				this.$message.warning("请五分钟后再次刷新！")
				return
			}
			this.fnInit()
			this.isLock = true
			this.$message.success("已刷新！")
			let _that = this
			setTimeout(()=>{
				_that.isLock = false
			},300000)
		},
		// 获取搜索框项目名
		fnGetProjectName(){
			request({
			  url: "enterprice/getAttendanceProjects",
			  method: "GET",
			})
			.then(res => {
				this.projectName = res.data
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 搜索考勤按月统计数据
		fnSearchAttendance(){
			let _id = this.searchProName
			let _month = this.searchMonth
			let _obj = {
				project_id: _id,
				type: 1,
				month: _month
			}
			this.fnGetAttrMonthData(_obj)
		},
		// 获取考勤按月统计数据
		fnGetAttrMonthData(_obj){
			request({
			  url: "enterprice/getMonthAttendance",
			  method: "GET",
				params: _obj
			})
			.then(res => {
				if(res.data){
					let _data = res.data
					for(let i in _data){
						let _rate = _data[i]["attendance_person"] / _data[i]["count_person"];
						_rate = _rate ? parseInt(_rate * 100) : 0;
						_data[i].att_rate = _rate == _rate ? _rate : 0
					}
					let _arr = []
					for(let j in _data){
						let _obj = {}
						_obj.id = j
						_obj.project_name = _data[j]['project_name']
						_obj.count_person = _data[j]['count_person']
						_obj.attendance_person = _data[j]['attendance_person']
						_obj.att_count = _data[j]['att_count']
						_obj.att_rate = _data[j]['att_rate']
						_arr.push(_obj)
					}
					this.attendanceData = _arr
				}
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 排序方法
		fnCompare(prop,rev) {
			if(rev === undefined) {
				rev = 1;
			}else {
				rev = rev ? 1: -1;
			}
			return function(obj1,obj2) {
				var val1 = obj1[prop],
						val2 = obj2[prop];
				return val1 < val2 ? rev*(-1) : rev*1;
			}
		},
		// 按总人数排序
		fnSortTotal(){
			this.sortTotal = !this.sortTotal
			let _data = this.attendanceData
			_data.sort(this.fnCompare('count_person',!this.sortTotal))
			this.attendanceData = _data
		},
		// 按出勤人数排序
		fnSortAtt(){
			this.sortAttr = !this.sortAttr
			let _data = this.attendanceData
			_data.sort(this.fnCompare('attendance_person',!this.sortAttr))
			this.attendanceData = _data
		},
		// 按出勤率排序
		fnSortAttRate(){
			this.sortAttrRate = !this.sortAttrRate
			let _data = this.attendanceData
			_data.sort(this.fnCompare('att_rate',!this.sortAttrRate))
			this.attendanceData = _data
		},
		// 按考勤总条数排序
		fnSortAttAll(){
			this.sortAttrAll = !this.sortAttrAll
			let _data = this.attendanceData
			_data.sort(this.fnCompare('att_count',!this.sortAttrAll))
			this.attendanceData = _data
		},
		// 获取安全统计数据
		fnGetSafetyData(){
			request({
			  url: "enterprice/SCountDetails",
			  method: "GET",
			})
			.then(res => {
				if(res.data){
					let _data = res.data
					let _arr = []
					let _timeTotal = 0
					let _timeoutTotal = 0
					let _ingTotal = 0
					let _notTotal = 0
					let _totalAll = 0
					for(let i in _data){
						let _obj = {}
						let _name = _data[i].name
						let	_timeNum = _data[i].rectify.ed.time_num
						let _timeoutNum = _data[i].rectify.ed.timeout_num
						let _ingNum = _data[i].rectify.ing.ing_num
						let _notNum = _data[i].rectify.not.not_num
						let _total = _data[i].rectify.total

						let _rate = (_timeNum + _timeoutNum) / _total
						_rate = _rate ? parseInt(_rate * 100) : 0
						_rate = _rate == _rate ? _rate : 0
						_obj = {
							_name,
							_timeNum,
							_timeoutNum,
							_ingNum,
							_notNum,
							_rate
						}
						_arr.push(_obj)
					}
					_arr.sort(this.fnCompare('_rate',false))

					this.safetyData = _arr
				}
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 获取质量统计数据
		fnGetQualityData(){
			request({
				url: "enterprice/QCountDetails",
				method: "GET",
			})
			.then(res => {
				if(res.data){
					let _data = res.data
					let _arr = []
					let _timeTotal = 0
					let _timeoutTotal = 0
					let _ingTotal = 0
					let _notTotal = 0
					let _totalAll = 0
					for(let i in _data){
						let _obj = {}
						let _name = _data[i].name
						let	_timeNum = _data[i].rectify.ed.time_num
						let _timeoutNum = _data[i].rectify.ed.timeout_num
						let _ingNum = _data[i].rectify.ing.ing_num
						let _notNum = _data[i].rectify.not.not_num
						let _total = _data[i].rectify.total

						let _rate = (_timeNum + _timeoutNum) / _total
						_rate = _rate ? parseInt(_rate * 100) : 0
						_rate = _rate == _rate ? _rate : 0
						_obj = {
							_name,
							_timeNum,
							_timeoutNum,
							_ingNum,
							_notNum,
							_rate
						}
						_arr.push(_obj)
					}
					_arr.sort(this.fnCompare('_rate',false))

					this.qualityData = _arr
				}
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
        // 跳转坐标拾取 子传父
        fnGetLocation(lng,lat){
            this.mapInfo.lng = lng
            this.mapInfo.lat = lat
        },
        // 确认选择的经纬度 关闭弹窗
        fnGetLocationYes(){
            this.form.lng = this.mapInfo.lng
            this.form.lat = this.mapInfo.lat
            this.showMap = false
        },
	}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.hello {
	width: 100vw;
	height: 100vh;
	background: url('../../../assets/img/enter_bg.png') no-repeat;
	background-size: 100% 100%;
	position: relative;
	overflow: hidden;
	.hello_box{
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.left_top{
	width: 750px;
	height: 306px;
	position: absolute;
	z-index: 111;
	top: 110px;
	left: 16px;
	background: url(../../../assets/img/enter_left_top_bg.png) no-repeat;
	background-size: 100% 100%;
	.top_title{
		width: 182px;
		height: 42px;
		position: absolute;
		top: 13px;
		left: 210px;
		background: url(../../../assets/img/enter_title.png) no-repeat;
		background-size: 100% 100%;
		font-size: 21px;
		font-family: "微软雅黑";
		line-height: 42px;
		color: #18f5ec;
		text-align: center;
	}
	.top_access{
		position: absolute;
		top: 60px;
		left: 50px;
		width: 600px;
		height: 230px;
		.access_item{
			position: relative;
			width: 85px;
			height: 112px;
			display: inline-block;
			top: 0;
			left: 0;
			margin: 0 30px;
			.item_bg{
				width: 81px;
				height: 67px;
				position: relative;
				top: 12px;
				left: 2px;
				background: url(../../../assets/img/enter_center_top.png) no-repeat;
				background-size: 100% 100%;
				.item_access{
					width: 79px;
					height: 72px;
					position: absolute;
					top: -12px;
					left: 2px;
					&.monitor{
						background: url(../../../assets/img/enter_center_monitor.png) no-repeat;
						background-size: 100% 100%;
					}
					&.led{
						background: url(../../../assets/img/enter_center_led.png) no-repeat;
						background-size: 100% 100%;
					}
					&.tower{
						background: url(../../../assets/img/enter_center_tower.png) no-repeat;
						background-size: 100% 100%;
					}
					&.elevator{
						background: url(../../../assets/img/enter_center_elevator.png) no-repeat;
						background-size: 100% 100%;
					}
					&.face{
						background: url(../../../assets/img/enter_center_face.png) no-repeat;
						background-size: 100% 100%;
					}
					&.environment{
						background: url(../../../assets/img/enter_center_environment.png) no-repeat;
						background-size: 100% 100%;
					}
					&.key{
						background: url(../../../assets/img/enter_center_key.png) no-repeat;
						background-size: 100% 100%;
					}
					&.helmet{
						background: url(../../../assets/img/enter_center_helmet.png) no-repeat;
						background-size: 100% 100%;
					}
				}
			}
			.item_txt{
				width: 81px;
				height: 29px;
				position: absolute;
				bottom: 0;
				left: 0;
				text-align: center;
				line-height: 15px;
				color: #51BDFF;
				font-size: 12px;
			}
		}
	}
}
.left_center{
	width: 750px;
	height: 307px;
	z-index: 111;
	position: absolute;
	top: 436px;
	left: 16px;
	background: url(../../../assets/img/enter_left_center_bg.png) no-repeat;
	background-size: 100% 100%;
	.project_total{
		width: 160px;
		height: 42px;
		line-height: 42px;
		position: absolute;
		right: 160px;
		text-align: right;
		top: 13px;
		color: rgba(255,255,255,0.8);
		font-size: 16px;
		span{
			font-size: 24px;
			color: rgba(255,25,25,0.8);
		}
	}
	.center_title{
		width: 182px;
		height: 42px;
		position: absolute;
		top: 13px;
		left: 210px;
		background: url(../../../assets/img/enter_title.png) no-repeat;
		background-size: 100% 100%;
		font-size: 21px;
		font-family: "微软雅黑";
		line-height: 42px;
		color: #18f5ec;
		text-align: center;
	}
	.center_search{
		width: 295px;
		height: 30px;
		position: absolute;
		top: 68px;
		left: 17px;
		@include flex-box(flex-start,center);
		.search_title{
			width: 62px;
			height: 26px;
			line-height: 26px;
			font-size: 12px;
			text-align: center;
			border-radius: 2px;
			color: #9BF9FC;
			background-color: rgba(155,249,252,0.1);
		}
		.search_input{
			width: 135px;
			height: 26px;
			line-height: 26px;
			padding-left: 8px;
			margin-right: 7px;
			outline:none;
			background-color: rgba(49,88,128,0.3);
			color: #4DB4F4;
			font-size: 12px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			border: none;
			&::-webkit-input-placeholder{
				color: #4DB4F4;
			}
			&::-moz-placeholder{   /* Mozilla Firefox 19+ */
				color: #4DB4F4;
			}
			&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
				color: #4DB4F4;
			}
			&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
				color: #4DB4F4;
			}
		}
		.search_btn{
			width: 91px;
			height: 28px;
			cursor: pointer;
			background: url(../../../assets/img/enter_select.png) no-repeat;
			background-size: 100% 100%;
		}
	}
	.center_list{
		width: 651px;
		height: 205px;
		position: absolute;
		top: 101px;
		left: 17px;
		.list_title{
			width: 651px;
			height: 40px;
			line-height: 40px;
			background: url(../../../assets/img/enter_left_bg.png) no-repeat;
			background-size: 100% 100%;
			.title_line{
				width: 640px;
				height: 40px;
				line-height: 28px;
				color: #FFFFFF;
				margin: 0 auto;
				@include flex-box(flex-start,center);
				.title_item{
					text-align: center;
					font-size: 14px;
					&:first-child{
						width: 80px;
					}
					&:nth-child(2){
						width: 170px;
					}
					&:nth-child(3){
						width: 150px;
					}
					&:nth-child(4){
						width: 60px;
					}
					&:nth-child(5){
						width: 180px;
					}
				}
			}
		}
		.list_boxes{
			width: 640px;
			height: 165px;
			margin: 0 auto;
			overflow: hidden;
			position: relative;
			.list_box{
				position: absolute;
				left: 0;
				right: -25px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.list_item{
					width: 640px;
					height: 42px;
					line-height: 42px;
					color: #FFFFFF;
					border-bottom: 1px dashed #0F2E5D;
					@include flex-box(flex-start,center);
					&:hover{
						background-color: rgba(49, 88, 128, 0.4);
					}
					.item_txt{
						text-align: center;
						font-size: 14px;
						margin: 0 2px;
						&:first-child{
							margin-left: 0;
							width: 78px;
						}
						&:nth-child(2){
							width: 166px;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space:nowrap;
						}
						&:nth-child(3){
							width: 146px;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space:nowrap;
						}
						&:nth-child(4){
							width: 56px;
						}
						&:nth-child(5){
							width: 180px;
							margin-right: 0;
						}
						.item_btn{
							background-color: transparent;
							border-radius: 2px;
							height: 22px;
							line-height: 22px;
							&.blue{
								width: 50px;
								color: #9BF9FC;
								border: 1px solid #9BF9FC;
								cursor: pointer;
							}
							&.red{
								width: 65px;
								height: 22px;
								color: #FF6971;
								border: 1px solid #FF6971;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
}
.left_bottom{
	width: 489px;
	height: 305px;
	position: absolute;
	top: 752px;
	left: 18px;
	background: url(../../../assets/img/enter_left_bottom.png) no-repeat;
	background-size: 100% 100%;
	.bottom_title{
		width: 150px;
		height: 22px;
		font-size: 22px;
		color: #6CEEAF;
		position: absolute;
		font-family: "微软雅黑";
		top: 16px;
		left: 30px;
	}
	.bottom_box{
		width: 436px;
		height: 120px;
		position: absolute;
		top: 90px;
		left: 25px;
		@include flex-box(flex-start,center);
		.box_total{
			width: 119px;
			height: 119px;
			margin-right: 40px;
			position: relative;
			@include flex-box(space-around,center);
			.project-rate{
				position: absolute;
				width: 130px;
				height: 130px;
			}
		}
		.box_attendance{
			width: 119px;
			height: 119px;
			position: relative;
			margin-right: 39px;
			@include flex-box(center,center);
			.img_count{
				width: 119px;
				height: 119px;
				color: #FFFFFF;
				font-size: 22px;
				background: url(../../../assets/images/total_quan_bg.png) no-repeat;
				background-size: 100% 100%;
				@include flex-box(center,center);
			}
			// .project-rate{
			// 	position: absolute;
			// 	width: 130px;
			// 	height: 130px;
			// }

		}
		.box_count{
			width: 119px;
			height: 119px;
			position: relative;
			@include flex-box(space-around,center);
			// .project-rate{
			// 	position: absolute;
			// 	width: 130px;
			// 	height: 130px;
			// }
			.img_count{
				width: 119px;
				height: 119px;
				color: #FFFFFF;
				font-size: 22px;
				background: url(../../../assets/images/total_quan_blb.png) no-repeat;
				background-size: 100% 100%;
				@include flex-box(center,center);
			}
		}
	}
	.bottom_txt{
		position: absolute;
		left: 25px;
		top: 210px;
		width: 436px;
		height: 30px;
		color: #fff;
		font-size: 14px;
		@include flex-box(space-between,center);
		.txt{
			width: 120px;
			text-align: center;

		}
	}
	.bottom_list{
		width: 460px;
		height: 60px;
		position: absolute;
		top: 240px;
		left: 15px;
		@include flex-box(center,center,column);
		.list_line{
			width: 460px;
			height: 30px;
			line-height: 30px;
			color: #FFFFFF;
			font-size: 14px;
			@include flex-box(center,center);
			.item{
				width: 100px;
				height: 30px;
				line-height: 30px;
				@include flex-box(center,center);
				.color{
					width: 20px;
					height: 14px;
					border-radius: 2px;
					margin-right: 5px;
					&.green{
						background-color: #6CEEAF;
					}
					&.blue{
						background-color: #4D81F7;
					}
					&.yellow{
						background-color: #FFCC3F;
					}
					&.lightblue{
						background-color: #9BF9FC;
					}
					&.red{
						background-color: #FF6A72;
					}
					&.pink{
						background-color: #F368E0;
					}
					&.gray{
						background-color: #8A8F97;
					}
					&.orange{
						background-color: #E67E23;
					}
				}
			}
		}
	}
}
.center_center{
	width: 590px;
	height: 590px;
	z-index: 100;
	position: absolute;
	top: 135px;
	left: 662px;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 0 20px rgba(0,0,0,0.6);
}
.center_bottom{
	width: 883px;
	height: 307px;
	position: absolute;
	top: 755px;
	left: 517px;
	background: url(../../../assets/img/enter_center_bottom.png) no-repeat;
	background-size: 100% 100%;
	.bottom_title{
		width: 150px;
		height: 22px;
		font-size: 22px;
		color: #6CEEAF;
		position: absolute;
		font-family: "微软雅黑";
		top: 13px;
		left: 30px;
	}
	.bottom_chart{
		position: relative;
		width: 840px;
		height: 280px;
		left: 20px;
		top: 50px;
	}
	.bottom_btn{
		width: 91px;
		height: 28px;
		position: absolute;
		top: 40px;
		right: 21px;
		cursor: pointer;
		background: url(../../../assets/img/enter_update.png) no-repeat;
		background-size: 100% 100%;
		border: none;
	}
}
.right_top{
	width: 756px;
	height: 306px;
	z-index: 111;
	position: absolute;
	top: 110px;
	left: 1148px;
	background: url(../../../assets/img/enter_right_top_bg.png) no-repeat;
	background-size: 100% 100%;
	.top_title{
		width: 182px;
		height: 42px;
		position: absolute;
		top: 13px;
		left: 300px;
		background: url(../../../assets/img/enter_title.png) no-repeat;
		background-size: 100% 100%;
		font-size: 21px;
		font-family: "微软雅黑";
		line-height: 42px;
		color: #18f5ec;
		text-align: center;
	}
	.top_search{
		width: 450px;
		height: 28px;
		position: absolute;
		top: 80px;
		left: 80px;
		@include flex-box(flex-start,center);
		.search_select{
			width: 200px;
			height: 26px;
			border-radius: 2px;
		}
		.search_date{
			width: 120px;
			height: 26px;
			border-radius: 2px;
			margin-left: 9px;
		}
		.search_btn{
			width: 91px;
			height: 28px;
			margin-left: 32px;
			cursor: pointer;
			background: url(../../../assets/img/enter_right_select.png) no-repeat;
			background-size: 100% 100%;
			border: none;
		}
	}
	.top_list{
		width: 601px;
		height: 194px;
		position: absolute;
		top: 112px;
		right: 20px;
		.list_title{
			width: 601px;
			height: 41px;
			line-height: 41px;
			background: url(../../../assets/img/enter_right_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(center,center);
			.title_line{
				width: 590px;
				height: 32px;
				line-height: 32px;
				@include flex-box(flex-start,center);
				.title_item{
					text-align: center;
					font-size: 14px;
					color: #EEBB6C;
					@include flex-box(center,center);
					&:nth-child(1){
						width: 170px;
					}
					&:nth-child(2){
						width: 105px;
					}
					&:nth-child(3){
						width: 105px;
					}
					&:nth-child(4){
						width: 105px;
					}
					&:nth-child(5){
						width: 105px;
					}
					.sort{
						width: 15px;
						height: 40px;
						@include flex-box(center,center,column);
						img{
							cursor: pointer;
							width: 11px;
							height: 7px;
						}
					}
				}
			}
		}
		.list_boxes{
			width: 590px;
			height: 150px;
			margin-left: 6px;
			overflow: hidden;
			position: relative;
			.list_box{
				position: absolute;
				left: 0;
				right: -20px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.list_item{
					width: 590px;
					height: 41px;
					line-height: 41px;
					color: #FFFFFF;
					border-bottom: 1px dashed #0F2E5D;
					@include flex-box(flex-start,center);
					&:hover{
						background-color: rgba(49, 88, 128, 0.4);
					}
					.item_one{
						text-align: center;
						font-size: 14px;
						margin: 0 2px;
						&:first-child{
							margin-left: 0;
							width: 168px;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space:nowrap;
						}
						&:nth-child(2){
							width: 101px;
						}
						&:nth-child(3){
							width: 101px;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space:nowrap;
						}
						&:nth-child(4){
							width: 101px;
						}
						&:nth-child(5){
							width: 105px;
							margin-right: 0;
						}
					}
				}
			}
		}
	}
}
.right_center{
	width: 756px;
	height: 306px;
	position: absolute;
	z-index: 1;
	top: 436px;
	left: 1148px;
	background: url(../../../assets/img/enter_right_center_bg.png) no-repeat;
	background-size: 100% 100%;
	.center_title{
		width: 182px;
		height: 42px;
		position: absolute;
		top: 13px;
		left: 300px;
		background: url(../../../assets/img/enter_title.png) no-repeat;
		background-size: 100% 100%;
		font-size: 21px;
		font-family: "微软雅黑";
		line-height: 42px;
		color: #18f5ec;
		text-align: center;
	}
	.center_list{
		width: 600px;
		height: 224px;
		position: absolute;
		top: 79px;
		left: 141px;
		.list_title{
			width: 600px;
			height: 41px;
			line-height: 41px;
			background: url(../../../assets/img/enter_right_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(center,center);
			.title_line{
				width: 590px;
				height: 32px;
				line-height: 32px;
				color: #EEBB6C;
				font-size: 14px;
				@include flex-box(flex-start,center);
				.title_item{
					text-align: center;
					width: 80px;
					&:nth-child(2){
						width: 110px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						cursor: pointer;
					}
				}
			}
		}
		.list_boxes{
			width: 590px;
			height: 170px;
			margin-top: 10px;
			overflow: hidden;
			position: relative;
			.list_box{
				position: absolute;
				left: 0;
				right: -20px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.list_item{
					width: 590px;
					height: 41px;
					line-height: 41px;
					@include flex-box(flex-start,center);
					&:hover{
						background-color: rgba(49, 88, 128, 0.4);
					}
					.item_one{
						text-align: center;
						width: 80px;
						font-size: 14px;
						color: #FFFFFF;
						border-bottom: 1px dashed #0F2E5D;
						&:nth-child(2){
							width: 110px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
}
.right_bottom{
	width: 489px;
	height: 308px;
	position: absolute;
	top: 749px;
	left: 1416px;
	background: url(../../../assets/img/enter_right_bottom_bg.png) no-repeat;
	background-size: 100% 100%;
	.bottom_title{
		position: absolute;
		left: 30px;
		top: 23px;
		width: 120px;
		height: 22px;
		line-height: 22px;
		font-size: 22px;
		font-family: "微软雅黑";
		color: #EEBB6C;
	}
	.bottom_list{
		position: absolute;
		width: 460px;
		height: 238px;
		top: 64px;
		left: 10px;
		.list_title{
			width: 460px;
			height: 41px;
			background: url(../../../assets/img/enter_right_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(center,center);
			.title_line{
				width: 460px;
				height: 30px;
				line-height: 30px;
				color: #EEBB6C;
				font-size: 14px;
				@include flex-box(flex-start,center);
				.title_item{
					text-align: center;
					width: 65px;
					&:nth-child(2){
						width: 70px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						cursor: pointer;
					}
				}
			}
		}
		.list_boxes{
			width: 460px;
			height: 197px;
			overflow: hidden;
			position: relative;
			.list_box{
				position: absolute;
				left: 0;
				right: -20px;
				top: 0;
				bottom: 0;
				overflow-x: hidden;
				overflow-y: auto;
				.list_item{
					width: 460px;
					height: 41px;
					line-height: 41px;
					@include flex-box(flex-start,center);
					.item_one{
						text-align: center;
						width: 65px;
						font-size: 14px;
						color: #FFFFFF;
						border-bottom: 1px dashed #0F2E5D;
						&:nth-child(2){
							width: 70px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
}

// 修改右侧下拉列表样式
.top_search{
	>>>.el-input__inner{
		width: 200px;
		height: 26px;
		border-radius: 2px;
		border: none;
		color: rgba(238, 187, 108,0.7);
		background-color: rgba(238, 187, 108,0.2);
		&::-webkit-input-placeholder{
			color: rgba(238, 187, 108,0.7);
		}
		&::-moz-placeholder{   /* Mozilla Firefox 19+ */
			color: rgba(238, 187, 108,0.7);
		}
		&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
			color: rgba(238, 187, 108,0.7);
		}
		&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
			color: rgba(238, 187, 108,0.7);
		}
	}
	>>>.el-select {
		.el-input {
			.el-select__caret{
				color: rgba(183, 147, 91,1);
			}
		}
	}
	>>>.el-select-dropdown{
		background-color: rgba(53, 53, 53,1);
		border: 1px solid rgba(183, 147, 91,1);
	}
	>>>.popper__arrow{
		border-bottom-color: rgba(183, 147, 91,1)!important;
	}
	>>>.el-select-dropdown__item{
		color: rgba(255, 255, 255,1);
	}
	>>>.el-select-dropdown__item:hover{
			color:#409eff;
	}
	>>>.el-select-dropdown__item.hover{
			color:#409eff;
	}
}
.search_date{
	>>>.el-input__inner{
				width: 120px!important;
				height: 26px!important;
			}
	>>>.el-input__icon{
			color: rgba(238, 187, 108,0.7);
		}
}
.dialog{
	.btn_line{
		@include flex-box(center,center);
	}
	>>>.el-dialog{
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid #3a74dd;
	}
	>>>.el-form-item__label{
		color: #4DB4F4;
	}
	>>>.el-dialog__title{
		color: #4DB4F4;
	}

	>>>.el-input__inner{
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background-color: rgba(77, 180, 244, 0.2);
		&::-webkit-input-placeholder{
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder{   /* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-input.is-disabled .el-input__inner{
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background-color: rgba(77, 180, 244, 0.2);
		&::-webkit-input-placeholder{
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder{   /* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder{  /* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-radio{
		color: #4DB4F4;
	}
	>>>.el-radio__inner{
		border: 1px solid rgba(77, 180, 244, 0.7);
	}
	>>>.el-dialog__close{
		color: #4DB4F4;
	}
}
.dialog_setMap{
    >>>.el-dialog {
    	width: 720px;
        height: 620px;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58,116,221,1);
        box-shadow: 0 0 12px rgba(255,255,255,0.2);
    }
    >>>.el-dialog__body{
      padding: 10px;
      height: 510px;
    }
    >>>.el-form-item__label{
    	color: #4DB4F4;
    }
    >>>.el-dialog__title{
    	color: #4DB4F4;
    }
    >>>.el-dialog__close{
    	color: #4DB4F4;
    }
    .btn_line{
        @include flex-box(center,center);
    }
    .show_map{
        width: 700px;
        height: 490px;
        z-index: 100;
        overflow: hidden;
        color: #4DB4F4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/EnterIndex/enterIndexDefault/index.vue